<template>
  <div id="logoslide" class="sliders">
    <slider v-if="render" ref="slider" :options="options">
      <slideritem
        v-for="(item, index) in logoList"
        :key="index"
        class="col-xs-12  col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex"
        :style="listStyle"
      > 
        <a :href="logoList[index].link" target="_blank" rel="noopener noreferrer">
        <img :src="logoList[index].url" class="images" />
        </a>
      </slideritem>
      <div slot="loading">loading...</div>
    </slider>
  </div>
</template>
<script>
import client from "../../utils/api.js";
import { slider, slideritem } from "vue-concise-slider";
export default {
  components: {
    slider,
    slideritem
  },
  data() {
    return {
      logoList: [],
      render: false,
      listStyle: {
        // margin: "0 10px",
        "margin": "0",
        "padding": "0",
        "align-items": "center",
        "justify-content": "center"
      },
      options: {
        loopedSlides: 4,
        autoplay: 3000,
        itemAnimation: true,
        slidesToScroll: 1,
        loop: true,
        pagination: false
      }
    };
  },
  mounted() {
    client
      .getEntries({ content_type: "sponsorlogo", order: "-sys.createdAt" })
      .then(response => {
        response.items.forEach(item => {
          var url = "https:" + item.fields.image.fields.file.url;
          this.logoList.push({"url" : url, "link": item.fields.title });
            
        });
        this.render = true;
      });
  }
};
</script>

<style scoped>
.bg {
  background: black;
}
.slider > .slick-list {
  width: 100% !important;
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .service {
    min-height: auto !important;
  }
}
.images {
  max-height: 180px;
  max-width: 300px
}
.sliders {
  width:100%;
  margin:20px auto;
  background: black;
  margin: 0
}
@media screen and (max-width: 992px) {
.images {
  max-height: 140px;
  max-width: 250px
}
}
</style>
